import React from "react";

function ApprovedIcon() {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.35 16.7C3.7383 16.7 0 12.9617 0 8.35C0 3.7383 3.7383 0 8.35 0C12.9617 0 16.7 3.7383 16.7 8.35C16.7 12.9617 12.9617 16.7 8.35 16.7ZM8.35 15.698C10.2988 15.698 12.1678 14.9238 13.5458 13.5458C14.9238 12.1678 15.698 10.2988 15.698 8.35C15.698 6.40119 14.9238 4.5322 13.5458 3.15418C12.1678 1.77616 10.2988 1.002 8.35 1.002C6.40119 1.002 4.5322 1.77616 3.15418 3.15418C1.77616 4.5322 1.002 6.40119 1.002 8.35C1.002 10.2988 1.77616 12.1678 3.15418 13.5458C4.5322 14.9238 6.40119 15.698 8.35 15.698ZM7.37138 10.4859L12.2219 5.63625L12.93 6.34517L7.96173 11.3134C7.80514 11.47 7.59279 11.5579 7.37138 11.5579C7.14997 11.5579 6.93762 11.47 6.78104 11.3134L4.175 8.70571L4.88392 7.9968L7.37222 10.4851L7.37138 10.4859Z"
        fill="white"
      />
    </svg>
  );
}

export default ApprovedIcon;
